<template>
    <div class="audit-order">
        <van-nav-bar title="订单审核" left-arrow @click-left="onClickLeft" fixed placeholder style="z-index: 3;" />
        
        <van-tabs v-model="activeTab" @change="onTabChange" >
            <van-tab title="全部" name="all"></van-tab>
            <van-tab title="待审核" name="0"></van-tab>
            <van-tab title="待发货" name="1"></van-tab>
            <van-tab title="待收货" name="2"></van-tab>
            <van-tab title="已完成" name="3"></van-tab>
        </van-tabs>

        <div class="order-list">
            <List v-model="loading" :finished="finished" :error="loadError" :error-text="loadErrorText"
                finished-text="没有更多了" @load="onLoad">
                <div v-for="item in list" :key="item.id" class="order-item" @click="goToDetail(item)">
                    <div class="order-user">
                        <img class="user-avatar" :src="item.user&&item.user.avatar" alt="头像" />
                        <span class="user-nickname">{{ item.user&&item.user.nickname }}</span>
                    </div>
                    <div class="order-header">
                        <span class="order-number">订单号：{{ item.ordersn }}</span>
                        <span class="order-status" :class="'status-' + item.status">{{ item.statusMsg }}</span>
                    </div>
                    <div class="order-content">
                        <div class="product-image">
                            <img :src="item.product&&item.product.image" alt="">
                        </div>
                        <div class="product-info">
                            <div class="product-name">{{ item.product&&item.product.name }}</div>
                            <div class="product-spec">规格：{{ item.product&&item.product.spec }}</div>
                            <div class="product-price">¥{{ item.product&&item.product.price }}</div>
                        </div>
                    </div>
                    <div class="order-footer">
                        <div class="order-detail">
                            <div class="detail-item">
                                <span class="label">购买数量：</span>
                                <span class="value">{{ item.purchase_number }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="label">支付金额：</span>
                                <span class="value price">¥{{ item.pay_price }}</span>
                            </div>
                        </div>
                        <div class="order-actions" @click.stop>
                            <van-button v-if="item.status == 0" type="primary" size="small" @click="handleAudit(item)">审核</van-button>
                        </div>
                    </div>
                </div>
            </List>
        </div>
    </div>
</template>

<script>
import { auditOrderList, auditOrder } from '@/api/my'
import { List } from 'vant'
export default {
    name: 'auditOrder',
    components: {
        List
    },
    data() {
        return {
            activeTab: 'all',
            page: 0,
            loading: false,
            finished: false,
            loadError: false,
            loadErrorText: '',
            list: [],
            employeeId: ''
        }
    },
    created() {
        let user = JSON.parse(localStorage.getItem('userDetails'))
        this.employeeId = user.mc_id
    },
    methods: {
        onClickLeft() {
            this.$router.back()
        },
        onTabChange(name) {
            console.log("切换Tab:", name)
            // 切换标签时重置列表
            this.page = 0
            this.list = []
            this.finished = false
            this.loadError = false
            this.loading = true
            this.onLoad()
        },
        onLoad() {
            console.log("onLoad")
            this.page++
            this.getOrderList()
        },
        getOrderList() {
            let _this = this
            this.loading = true
            auditOrderList({
                page: this.page,
                status: this.activeTab,
                user_id: this.employeeId
            }).then(res => {
                console.log(res)
                if (res.code == 1) {
                    res.data.list.forEach(item => {
                        item.address = JSON.parse(item.address)
                    })
                    _this.list = [...this.list, ...res.data.list]
                    if (res.data.list.length < 10) {
                        _this.finished = true
                    }
                    console.log("订单数据", _this.list)
                } else {
                    _this.loadError = true
                    _this.loadErrorText = res.msg
                }
            }).catch(err => {
                _this.loadError = true
                _this.loadErrorText = '加载失败，请重试'
            }).finally(() => {
                this.$nextTick(() => {
                    _this.loading = false
                })
            })
        },
        handleAudit(item) {
            this.$dialog.confirm({
                closeOnClickOverlay:true,
                cancelButtonText:'拒绝',
                confirmButtonColor:'#1890ff',
                cancelButtonColor:'#ee0a24',
                message: `确认审核订单：${item.ordersn}？`,
            }).then((res) => {
                console.log(res)
                this.submitAudit(item.ordersn,1)
            }).catch(() => {
                // 取消操作
                this.submitAudit(item.ordersn,4)
            })
        },
        submitAudit(ordersn,status) {
            auditOrder({
                ordersn: ordersn,
                status
            }).then(res => {
                console.log(res)
                if (res.code == 1) {
                    this.$toast.success('审核成功')
                    // 刷新列表
                    this.refreshList()
                } else {
                    this.$toast.fail(res.msg || '审核失败')
                }
            }).catch(err => {
                this.$toast.fail('审核请求失败，请重试')
            })
        },
        refreshList() {
            // 重置列表数据
            this.page = 0
            this.list = []
            this.finished = false
            this.loadError = false
            this.onLoad()
        },
        goToDetail(item) {
            // 跳转到订单详情页，传递订单数据
            this.$router.push({
                path: '/my/orderDetail',
                query: {
                    orderData: JSON.stringify(item)
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.audit-order {
    min-height: 100vh;
    background: #f2f3f7;
    box-sizing: border-box;
}

.order-list {
    padding: var(--base-px-12);
}

.order-user {
    display: flex;
    align-items: center;
    margin-bottom: var(--base-px-8);
    .user-avatar {
        width: var(--base-px-28);
        height: var(--base-px-28);
        border-radius: 50%;
        object-fit: cover;
        margin-right: var(--base-px-8);
        border: 1px solid #f0f0f0;
    }
    .user-nickname {
        font-size: var(--base-px-14);
        color: #333;
        font-weight: bold;
    }
}

.order-item {
    background: #fff;
    border-radius: var(--base-px-8);
    margin-bottom: var(--base-px-12);
    padding: var(--base-px-12);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: all 0.3s;
    
    &:active {
        background: #f5f5f5;
        transform: scale(0.98);
    }
}

.order-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: var(--base-px-12);
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: var(--base-px-12);
}

.order-number {
    font-size: var(--base-px-13);
    color: #666;
}

.order-status {
    font-size: var(--base-px-12);
    padding: var(--base-px-4) var(--base-px-8);
    border-radius: var(--base-px-4);
    
    &.status-0 {
        background: #fff7e6;
        color: #fa8c16;
    }
    
    &.status-1 {
        background: #e6f7ff;
        color: #1890ff;
    }
    
    &.status-2 {
        background: #f6ffed;
        color: #52c41a;
    }
}

.order-content {
    display: flex;
    align-items: center;
    margin-bottom: var(--base-px-12);
}

.product-image {
    width: var(--base-px-80);
    height: var(--base-px-80);
    border-radius: var(--base-px-8);
    overflow: hidden;
    flex-shrink: 0;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.product-info {
    flex: 1;
    margin-left: var(--base-px-12);
}

.product-name {
    font-size: var(--base-px-15);
    font-weight: 500;
    color: #333;
    margin-bottom: var(--base-px-4);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}

.product-spec {
    font-size: var(--base-px-12);
    color: #999;
    margin-bottom: var(--base-px-4);
}

.product-price {
    font-size: var(--base-px-14);
    color: #ff4d4f;
    font-weight: 500;
}

.order-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: var(--base-px-12);
    border-top: 1px solid #f0f0f0;
}

.order-detail {
    flex: 1;
}

.detail-item {
    font-size: var(--base-px-13);
    color: #666;
    margin-bottom: var(--base-px-4);
    
    &:last-child {
        margin-bottom: 0;
    }
    
    .label {
        color: #999;
    }
    
    .value {
        color: #333;
        
        &.price {
            color: #ff4d4f;
            font-weight: 500;
            font-size: var(--base-px-14);
        }
    }
}

.order-actions {
    display: flex;
    align-items: center;
    gap: var(--base-px-8);
}
</style>